import {abtest} from "./ab"

// Archive
//
// showFreeMinutesTitle: {
//   variants: {
//     'hidden': 100,
//     // 'visible': 20,
//   }
// },
// freeTrial: {
//   variants: {
//     // 7: 80,
//     0: 100,
//   }
// },
// pricingPage: {
//   variants: {
//     'old': 100,
//     // 'new': 20,
//   }
// },
// resultAds: {
//   variants: {
//     'old': 100,
//     // 'new': 20,
//   }
// },
// limitType3: {
//   variants: {
//     'freemium': 50,
//       'locs': 50,
//   }
// },
// price1: {
//   variants: {
//     9: 50,
//       9.99: 50,
//   }
// },

const AB_TESTS = {
  freeMinutes: { // started at 18 Mar 0 AM
    variants: {
      10: 100,
    }
  },
}

export function initABTests(amplitude) {
  const data = getExperimentsData()
  
  // console.log(data)

  amplitude.identify(data)
}

export function getExperimentsData() {
  const data = {}
  
  for (const [name, options] of Object.entries(AB_TESTS)) {
    data[`ab_${name}`] = abtest(name, options.variants)
  }
  
  return data
}

export function getLimitType() {
  return "characters2"
}

export function getCharactersLimit() {
  return 500
}

/**
 * @deprecated
 @return: {9|9.99}
 */
export function getPrice1() {
  // return parseFloat(abtest("price1"))
  return 9.99
}

/**
 * @deprecated
  @return: {'new'|'old'}
 */
export function getResultAdsType() {
  // return abtest("resultAds")
  return 'old'
}

/**
 * @deprecated
  @return: {'new'|'old'}
 */
export function getPricingPage() {
  // return abtest("pricingPage")
  return 'old'
}

// @deprecated
export function getShowFreeMinutesTitle() {
  return true
}

export function getLocLimit() {
  return 8
}

/**
 @return: {10}
 */
export function getFreeMinutes() {
  return parseInt(abtest("freeMinutes"))
}

export function getResultLimitWindow() {
  return 5 // was 10
}

export function getResultLimitTimeout() {
  return 10
}

// @deprecated
export function getTrialsDays() {
  // return parseInt(abtest('freeTrial'))
  return 0
}
